export default __webpack_public_path__ + "static/media/04.8c8e4104.jpg";